import { z } from 'zod';

export const TelegramMessageReceivedPayloadSchema = z.object({
  /** `telegram:<chatId>:<messageId>` — unique across chats, never collides with a wamid. */
  providerMessageId: z.string().min(1),
  chatId: z.string().regex(/^-?[1-9]\d{0,19}$/),
  senderName: z.string().nullable(),
  /** `from.username`, without "@"; null when the sender has none or the update carries no `from`. */
  senderUsername: z.string().min(1).nullable().default(null),
  /** `chat.type === 'private'`: only a private chat is a member's own Telegram account. */
  privateChat: z.boolean().default(false),
  /** The text; null for anything else (photo, sticker, voice, …). */
  body: z.string().nullable(),
  receivedAt: z.iso.datetime(),
});
export type TelegramMessageReceivedPayload = z.infer<typeof TelegramMessageReceivedPayloadSchema>;
